import angularModule from 'LearnerProjects/angularModule/scripts/learner_projects_module';
import hasDateAsTimestampInJson from 'hasDateAsTimestampInJson';

angularModule.factory('ProjectProgress', [
    '$injector',
    function ($injector) {
        const Iguana = $injector.get('Iguana');
        const ProjectProgressTimeline = $injector.get('ProjectProgressTimeline');

        return Iguana.subclass(function () {
            this.setCollection('project_progress');
            this.alias('ProjectProgress');
            this.setIdProperty('id');

            this.setCallback('after', 'copyAttrsOnInitialize', function () {
                this.historical_project_submissions = this.historical_project_submissions || [];
            });

            // Configure date-to-timestamp conversion for resubmissionDueDate
            hasDateAsTimestampInJson(this, 'resubmissionDueDate');

            // Clearing is a no-op when there is no submission. Writing a real value with nowhere to put it
            // is a bug, so fail loudly instead of silently.
            function setProvisionalOnSubmission(progress, attr, val) {
                if (progress.project_submission) {
                    progress.project_submission[attr] = val;
                    return;
                }
                if (val !== null && val !== undefined) {
                    throw new Error(`Cannot set ${attr} on a ProjectProgress with no project_submission`);
                }
            }

            Object.defineProperty(this.prototype, 'provisional_score', {
                get() {
                    return this.project_submission ? this.project_submission.provisional_score : undefined;
                },
                set(val) {
                    setProvisionalOnSubmission(this, 'provisional_score', val);
                },
            });

            Object.defineProperty(this.prototype, 'provisional_feedback', {
                get() {
                    return this.project_submission ? this.project_submission.provisional_feedback : undefined;
                },
                set(val) {
                    setProvisionalOnSubmission(this, 'provisional_feedback', val);
                },
            });

            return {
                getCorrespondingTimelineEvents() {
                    return ProjectProgressTimeline.show(this.id).then(
                        response => (response.result && response.result.events) || [],
                    );
                },

                objectForSave($super) {
                    const json = $super();
                    json.project_submission_similarity_and_originality_status =
                        this.project_submission_similarity_and_originality_status;
                    json.project_submission_needs_admin_review = this.project_submission_needs_admin_review;
                    json.project_submission_private_notes = this.project_submission_private_notes;
                    json.project_submission_presentation_transcript = this.project_submission_presentation_transcript;

                    // Only send it when the nested submission actually carries provisional (the cohort_gradebook
                    // serialization), so other save contexts don't touch it.
                    if (this.project_submission && 'provisional_score' in this.project_submission) {
                        json.project_submission_provisional_score = this.project_submission.provisional_score ?? null;
                        json.project_submission_provisional_feedback =
                            this.project_submission.provisional_feedback ?? null;
                    }

                    return json;
                },
            };
        });
    },
]);
